import React from 'react';
import { FadeIn } from './FadeIn';
const cards = [{
  title: 'Education',
  items: ['Logic & Rhetoric', 'Systems Thinking', 'Self-Regulation', 'Historical Analysis']
}, {
  title: 'Institutional Design',
  items: ['Reward Competence', 'Reduce Corruption', 'Resist Capture', 'Align Incentives']
}, {
  title: 'Public Development',
  items: ['Civic Pathways', 'Continuous Training', 'Neuro-feedback', 'Status Advancement']
}, {
  title: 'Cognitive Sovereignty',
  items: ['Disinformation Defense', 'Manipulation Resistance', 'Attention Protection', 'Cultural Hardening']
}];
export function DevelopmentalStatecraft() {
  return <section className="py-24 md:py-32 bg-cognarch-offwhite relative border-t border-cognarch-border" data-id="element-42">
      <div className="max-w-7xl mx-auto px-6" data-id="element-43">
        <FadeIn data-id="element-44">
          <div className="mb-16 md:mb-24" data-id="element-45">
            <h2 className="text-3xl md:text-5xl font-serif mb-6 text-cognarch-charcoal" data-id="element-46">
              Developmental Statecraft
            </h2>
            <p className="text-cognarch-gray max-w-2xl text-lg" data-id="element-47">
              The state is no longer a neutral referee of competing interests;
              it is an active Architect of Human Development.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-24" data-id="element-48">
          {cards.map((card, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-49">
              <div className="bg-cognarch-white border border-cognarch-border p-8 h-full hover:border-cognarch-charcoal/30 transition-colors" data-id="element-50">
                <h3 className="text-xl font-serif text-cognarch-charcoal mb-6 pb-4 border-b border-cognarch-border" data-id="element-51">
                  {card.title}
                </h3>
                <ul className="space-y-4" data-id="element-52">
                  {card.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-cognarch-gray text-sm" data-id="element-53">
                      <span className="text-cognarch-charcoal/40 mt-1 text-xs" data-id="element-54">
                        ◆
                      </span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-55">
          <div className="relative py-16 text-center border-y border-cognarch-border" data-id="element-56">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-px bg-cognarch-charcoal" data-id="element-57" />
            <h3 className="text-3xl md:text-5xl font-serif text-cognarch-charcoal leading-tight max-w-4xl mx-auto text-balance" data-id="element-58">
              "The aim is not simply to govern society,{' '}
              <br className="hidden md:block" data-id="element-59" />
              <span className="italic" data-id="element-60">but to raise it.</span>"
            </h3>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-32 h-px bg-cognarch-charcoal" data-id="element-61" />
          </div>
        </FadeIn>
      </div>
    </section>;
}